<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div
        id="inspection-report-list"
        class="col-sm-12"
    >
        <div>
                <div class="col-sm-12 search-form-title">
                    <i class="fas fa-search"></i>
                    {{ $t('common.search') }}
                </div>
                    <div class="row nopads">
                        <div class="col-sm-6">
                            <label class="search-title" for="from_date">
                                {{ $t('ins_report.from_date') }}
                            </label>
                            <input
                                id="from_date"
                                v-model="fromDate"
                                type="date"
                                class="form-control form-control-sm no-margin"
                            />
                        </div>
                        <div class="col-sm-6">
                            <label class="search-title" for="to_date">
                                {{ $t('ins_report.to_date') }}
                            </label>
                            <input
                                id="to_date"
                                v-model="toDate"
                                type="date"
                                class="form-control form-control-sm"
                            />
                        </div>
                    </div>

                    <div class="row nopads mt-2">
                        <div class="col-sm-6">
                            <label class="span-title" for="type">
                                {{ $t('ins_report.select_type') }}
                            </label>
                            <select
                                id="type"
                                v-model="type"
                                class="form-select form-select-sm"
                            >
                                <option
                                    v-for="type in types"
                                    :key="type.value"
                                    :value="type.value"
                                >
                                    {{ type.text }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col-sm-12 button-container mt-3">
                        <button
                            type="button"
                            class="btn btn-success form-button me-2"
                            @click.stop="$emit('add')"
                        >
                            {{ $t('menu.new_inspection') }}
                        </button>
                        <button class="btn btn-danger form-button me-2" @click.stop="onResetSearch">
                            {{ $t('ins_report.clear') }}
                        </button>
                        <button class="btn btn-primary form-button" @click.stop="onSubmitSearch">
                            {{ $t('ins_report.search') }}
                        </button>
                    </div>
            </div>
        <hr/>
        <Transition name="fade">
            <div
                v-if="tableItems.length > 0"
                class="col-sm-12 list-container px-0"
            >
                <div
                    class="col-sm-12 nopads"
                >
                    <div class="col-12 d-flex justify-content-end">
                        <div class="col-6">
                            <input v-model="query" type="text"  class="form-control form-control-sm my-2" placeholder="Search..." />
                        </div>
                    </div>

                    <!-- Main table element -->
                    <vue3-datatable
                        ref="resultTable"
                        :rows="tableItems"
                        :columns="fields"
                        :pagination="false"
                        :sticky-header="true"
                        :search="query"
                        height="40em"
                        :sortable="true"
                        skin="bh-table-compact"
                        :row-class="getRowClass"
                        cell-class="routa-table-cell"
                        @row-click="emitDetails"
                    >
                        <template #created="data">{{ data.value.createdTime }}</template>

                        <template #outcome="data">
                            <font-awesome-icon
                                v-if="hasStatus(data.value.results, resultBan)"
                                icon="exclamation-circle"
                                class="ban"
                            />
                            <font-awesome-icon
                                v-else-if="hasStatus(data.value.results, resultDefect)"
                                icon="exclamation-circle"
                                class="defect"
                            />
                        </template>
                    </vue3-datatable>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script>
import {inspectionHelper} from '../mixins/InspectionMixin'
import {timeUtils} from '../mixins/TimeUtils'
import Vue3Datatable from '@bhplugin/vue3-datatable'

export default {
    name: 'InspectionReportList',
    mixins: [inspectionHelper, timeUtils],
    components: {Vue3Datatable},
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            fromDate: '',
            toDate: '',
            query: '',
            type: null,
            tableItems: [],
            selectedRowId: null,
            types: [
                {value: null, text: this.$t('observations.search_all')},
                {value: 1, text: this.$t('inspection_template.type.vehicle')},
                {value: 2, text: this.$t('inspection_template.type.work')},
                {value: 3, text: this.$t('inspection_template.type.task')},
                {value: 4, text: this.$t('inspection_template.type.company')},
                {value: 5, text: this.$t('inspection_template.type.bridge')},
                {value: 6, text: this.$t('inspection_template.type.culvert')},
                //{value: 7, text: this.$t('inspection_template.type.harja_bridge')},
                {value: 8, text: this.$t('inspection_template.type.user')}
            ],
            fields: [
                {field: 'outcome', title: '', sort: false, headerClass: 'routa-table-header'},
                {field: 'id', title: this.$t('common.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'created', title: this.$t('ins_report.list_label.created'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'type', title: this.$t('ins_report.list_label.report_type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'name', title: this.$t('ins_report.list_label.name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'frequency', title: this.$t('inspection_editor.inspection_frequency'), sort: true, headerClass: 'routa-table-header'},
                {field: 'target', title: this.$t('ins_report.list_label.target'), sort: true, headerClass: 'routa-table-header'},
                {field: 'inspector', title: this.$t('ins_report.list_label.inspector'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contract', title: this.$t('ins_report.list_label.contract'), sort: true, headerClass: 'routa-table-header' },
                {field: 'areas', title: this.$t('menu.areas'), sort: true, headerClass: 'routa-table-header' }
            ]
        }
    },
    watch: {
        results() {
            // Convert to table items
            let temp = []
            this.tableItems = []
            this.results.forEach(item => {
                    const areaString = item.areas ? item.areas.map(item => item.name).join(', ') : ''
                    temp.push({
                        'id': item.id,
                        'type': this.getInspectionTypeName(item.type),
                        'created': new Date(item.created).getTime(),
                        'createdTime': this.toLocalTime(item.created),
                        'name': item.name,
                        'frequency': this.getInspectionFrequency(item.frequency),
                        'target': this.getInspectionTarget(item),
                        'inspector': this.getInspector(item.reporter),
                        'results': item.results,
                        'contract': item.contract ? item.contract.name : '',
                        'areas': areaString
                    })
            }
            )
            this.$nextTick(() => this.tableItems = temp )
        }
    },
    mounted() {
        if (!this.fromDate) {
            let now = new Date()
            now.setDate(1)
            this.fromDate = this.timestampToDateInput(now.getTime())
        }
    },
    methods: {
        rowClicked(item) {
            this.$emit('rowClicked', item)
            this.selectedRowId = item ? item.id : null
        },

        getRowClass(row) {
            return row.id === this.selectedRowId ? 'routa-table-row selected-row row-id-' + row.id : 'routa-table-row  row-id-' + row.id
        },

        setSelection(index) {
            this.selectedRowId = null
            if (index >= 0 && index < this.trips.length) {
                this.selectedRowId = this.trips[index].id
            }
        },

        resetSelection() {
            this.selectedRowId = null
        },

        onResetSearch: function () {
            this.fromDate = ''
            this.toDate = ''
        },

        onSubmitSearch: function () {
            var params = {}
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.from = this.localTimeToUtcTime(this.fromDate).toISOString()
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.to = this.getEndOfTheDay(this.toDate).toISOString()
            }
            params.type = this.type
            this.$emit('search', params)
        },
        emitDetails: function (details) {
            let item = this.results.find(report => report.id === details.id)
            if (item) {
                this.$emit('details', item)
            }
        },
        hasStatus: function (results, status) {
            return results.find(item => item.result === status) !== undefined
        },
        sortCompare(aRow, bRow, key, sortDesc, formatter, compareOptions, compareLocale) {
            if (key === 'inspector') {
                const a = this.getInspector(aRow['reporter'])
                const b = this.getInspector(bRow['reporter'])
                return a.localeCompare(b, compareLocale, compareOptions)
            } else if (key === 'target') {
                const a = this.getInspectionTarget(aRow)
                const b = this.getInspectionTarget(bRow)
                return a.localeCompare(b, compareLocale, compareOptions)
            } else if (key === 'created') {
                const a = aRow.created
                const b = bRow.created
                return a < b ? -1 : a > b ? 1 : 0
            } else if (key === 'frequency') {
                const a = this.getInspectionFrequency(aRow.frequency)
                const b = this.getInspectionFrequency(bRow.frequency)
                return a < b ? -1 : a > b ? 1 : 0
            }
            return false
        }
    }
}
</script>
